/**
 * Form validation utilities
 */

export const validationRules = {
  required: (message = 'Este campo é obrigatório') => (value) => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return message;
    }
    return null;
  },

  email: (message = 'Email inválido') => (value) => {
    if (!value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) ? null : message;
  },

  minLength: (min, message) => (value) => {
    if (!value) return null;
    return value.length >= min ? null : message || `Mínimo de ${min} caracteres`;
  },

  maxLength: (max, message) => (value) => {
    if (!value) return null;
    return value.length <= max ? null : message || `Máximo de ${max} caracteres`;
  },

  phone: (message = 'Telefone inválido') => (value) => {
    if (!value) return null;
    const phoneRegex = /^\(\d{2}\)\s\d{4,5}-\d{4}$/;
    return phoneRegex.test(value) ? null : message;
  },

  cpf: (message = 'CPF inválido') => (value) => {
    if (!value) return null;
    
    // Remove non-digits
    const cpf = value.replace(/\D/g, '');
    
    if (cpf.length !== 11) return message;
    
    // Check for repeated digits
    if (/^(\d)\1{10}$/.test(cpf)) return message;
    
    // Validate CPF algorithm
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) return message;
    
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) return message;
    
    return null;
  },
};

/**
 * Lead form validation schema
 */
export const leadValidationSchema = {
  name: [
    validationRules.required('Nome é obrigatório'),
    validationRules.minLength(2, 'Nome deve ter pelo menos 2 caracteres'),
    validationRules.maxLength(100, 'Nome deve ter no máximo 100 caracteres'),
  ],
  email: [
    validationRules.required('Email é obrigatório'),
    validationRules.email(),
  ],
  city: [
    validationRules.required('Cidade é obrigatória'),
    validationRules.minLength(2, 'Cidade deve ter pelo menos 2 caracteres'),
  ],
  state: [
    validationRules.required('Estado é obrigatório'),
  ],
};

/**
 * Format phone number
 */
export const formatPhone = (value) => {
  if (!value) return value;
  
  const phone = value.replace(/\D/g, '');
  
  if (phone.length <= 2) {
    return `(${phone}`;
  } else if (phone.length <= 6) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2)}`;
  } else if (phone.length <= 10) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
  } else {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7, 11)}`;
  }
};

/**
 * Format CPF
 */
export const formatCPF = (value) => {
  if (!value) return value;
  
  const cpf = value.replace(/\D/g, '');
  
  if (cpf.length <= 3) {
    return cpf;
  } else if (cpf.length <= 6) {
    return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
  } else if (cpf.length <= 9) {
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;
  } else {
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9, 11)}`;
  }
};